"use client";
import React from 'react';
import './StepperProgress.css';
import { ReactComponent as Step1 } from '../../assets/icon-step/step1.svg';
import { ReactComponent as Step2 } from '../../assets/icon-step/step2.svg';
import { ReactComponent as Step3 } from '../../assets/icon-step/step3.svg';
import { ReactComponent as Step4 } from '../../assets/icon-step/step4.svg';
import { ReactComponent as Step5 } from '../../assets/icon-step/step5.svg';

const steps = [
  { label: "Datos del asegurado de ATM", icon: <Step1 className="w-10 h-10" />, title: 'Ahora, comenzamos con la carga de tu reclamo como tercero' },
  { label: "Datos del siniestro", icon: <Step2 className="w-10 h-10" />, title: 'Ahora, continuamos con los datos del siniestro' },
  { label: "Tus datos", icon: <Step3 className="w-10 h-10" />, title: 'Ahora, continuamos con tus datos' },
  { label: "Documentación", icon: <Step4 className="w-10 h-10" />, title: 'Ahora, continuamos con la carga de la documentación' },
  { label: "Denuncia presentada", icon: <Step5 className="w-10 h-10" />, title: 'Denuncia fue presentada con exito' }
];

const StepperProgress = ({ currentStep }) => {
  const stepIndex = Math.floor(parseFloat(currentStep) || 0); // protege contra strings tipo '3.2', null, undefined

  if (stepIndex <= 0 || stepIndex > steps.length) return null;

  const current = steps[stepIndex - 1];
  const remaining = steps.length - stepIndex;

  return (
    <>
      {current && (
        <p className="text-2xl md:text-3xl text-red font-medium block text-center mt-5 md:mt-7 px-5 md:px-0">
          {current.title}
        </p>
      )}

      {/* Mobile Progress Bar */}
      <div className='flex justify-center md:hidden mt-8 w-full'>
        <div className="flex flex-col items-center gap-y-4 w-full">
          <div className='bg-white'>{current.icon}</div>
          <div className="relative flex flex-row w-full justify-center">
            {stepIndex > 1 && <div className='border-2 border-red absolute start-0 top-[40%] w-1/2 z-0'></div>}
            <div className="w-auto z-10">
              <div className='relative w-5 h-5 rounded-full flex items-center justify-center border-2 bg-white border-red text-red'>
                <div className="w-3 h-3 bg-red rounded-full"></div>
              </div>
            </div>
            {remaining > 0 && (
              <p className='absolute end-0 text-xs mt-6 text-shiny-pink px-3'>
                {remaining === 1 ? 'Queda 1 paso' : `Quedan ${remaining} pasos`}
              </p>
            )}
            {stepIndex < steps.length && <div className='border-2 border-shiny-pink absolute end-0 top-[40%] w-1/2 z-0'></div>}
          </div>
          <p className='text-sm text-center font-semibold text-red'>{current.label}</p>
        </div>
      </div>

  
      <div className="stepper-progress md:flex items-center justify-between w-full my-14 px-4 hidden">
        {steps.map((step, index) => {
          const stepNumber = index + 1;
          const isCompleted = stepNumber < stepIndex;
          const isActive = stepNumber === stepIndex;

          return (
            <div key={index} className="flex flex-col items-center flex-1 relative">
              {isActive ? (
                <div className='bg-white p-1'>{step.icon}</div>
              ) : (
                <div className={`w-6 h-6 rounded-full flex items-center justify-center border-2 ${isCompleted ? 'bg-red border-red text-white' : 'bg-white border-pink text-pink'}`}></div>
              )}
              <p className={`text-sm text-center mt-4 font-semibold ${isCompleted || isActive ? 'text-red' : 'text-pink'}`}>{step.label}</p>
              {index < steps.length - 1 && (
                <div className={`absolute left-1/2 w-full h-0.5 -z-10 ${isActive ? 'top-5' : 'top-2'}`}>
                  <div className={`h-full ${isCompleted ? 'bg-red' : 'bg-pink'} transition-all`}></div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};

export default StepperProgress;